import * as React from "react";

interface LabelProps {
  type: "paragraph" | "paragraph-2" | "header-1" | "header-2" | "header-3" | "header-4" | "subtitle" | "subtitle-2";
  text?: string;
  color?: string;
  underlineWidth?: number;
  underlineColor?: string;
  id?: string;
  className?: string;
  onClick?: () => void;
  "data-cy"?: string;
}

/** @deprecated Use <Text /> instead */
export class Label extends React.Component<LabelProps> {
  render() {
    let style: React.CSSProperties = {};
    if (this.props.color) {
      style = { color: this.props.color };
    }
    let className = this.props.type;
    if (this.props.className) {
      className += " " + this.props.className;
    }

    if ((this.props.type === "header-2" && this.props.underlineWidth !== 0) || this.props.underlineWidth) {
      return (
        <div data-cy={this.props["data-cy"]} id={this.props.id ? this.props.id : ""} className={className} onClick={() => this.props.onClick?.()}>
          <p style={style}>{this.props.text}</p>
          <hr
            style={{
              maxWidth: this.props.underlineWidth ? this.props.underlineWidth : 50,
              backgroundColor: this.props.underlineColor ? this.props.underlineColor : "#E5E9F2",
            }}
          />
        </div>
      );
    } else {
      if (this.props.type === "header-2") {
        return (
          <h2
            data-cy={this.props["data-cy"]}
            className={className}
            style={style}
            id={this.props.id ? this.props.id : ""}
            onClick={() => this.props.onClick?.()}
          >
            {this.props.text}
          </h2>
        );
      } else if (["header-1", "subtitle", "subtitle-2"].includes(this.props.type)) {
        return (
          <h1
            data-cy={this.props["data-cy"]}
            className={className}
            style={style}
            id={this.props.id ? this.props.id : ""}
            onClick={() => this.props.onClick?.()}
          >
            {this.props.text}
          </h1>
        );
      } else {
        return (
          <p
            data-cy={this.props["data-cy"]}
            className={className}
            style={style}
            id={this.props.id ? this.props.id : ""}
            onClick={() => this.props.onClick?.()}
          >
            {this.props.text}
          </p>
        );
      }
    }
  }
}

